import OriginModal from './modal';
import confirm, { withWarning, withError, withConfirm } from './confirm';
export * from './modal';
var Modal = OriginModal;

Modal.warning = function infoFn(props) {
  return confirm(withWarning(props));
};

Modal.error = function infoFn(props) {
  return confirm(withError(props));
};

Modal.confirm = function infoFn(props) {
  return confirm(withConfirm(props));
};

export default Modal;